import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconMsTeams = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 75 69'
    {...props}
  >
    <path
      fill='#7B83EB'
      d='M39.826 21.705c6.034 0 10.938-4.867 10.938-10.852S45.874 0 39.826 0 28.888 4.867 28.888 10.853s4.89 10.852 10.938 10.852'
    />
    <path
      fill='currentColor'
      d='M39.043 13.172H29.14l.056.215.056.216a10.8 10.8 0 0 0 4.875 6.498 11.06 11.06 0 0 0 8.046 1.349v-5.177a3.07 3.07 0 0 0-.922-2.184 3.22 3.22 0 0 0-2.207-.917'
      opacity={0.1}
    />
    <path
      fill='currentColor'
      d='M36.697 15.504h-6.762a10.9 10.9 0 0 0 4.038 4.53 11.03 11.03 0 0 0 5.839 1.685v-3.1a3.07 3.07 0 0 0-.922-2.185 3.22 3.22 0 0 0-2.207-.917z'
      opacity={0.2}
    />
    <path
      fill='#5059C9'
      d='M64.412 22.474c4.526 0 8.2-3.64 8.2-8.143s-3.674-8.143-8.2-8.143-8.2 3.64-8.2 8.143 3.674 8.143 8.2 8.143M71.452 24.806H53.04c-.391 0-.783.162-1.062.432-.28.283-.433.66-.433 1.051v18.86a11.76 11.76 0 0 0 2.542 7.55 11.93 11.93 0 0 0 6.761 4.274c1.705.35 3.479.324 5.169-.08a11.8 11.8 0 0 0 4.638-2.28 11.7 11.7 0 0 0 3.199-4.03A11.5 11.5 0 0 0 75 45.58v-17.31c0-.93-.363-1.806-1.034-2.467a3.5 3.5 0 0 0-2.486-1.025z'
    />
    <path
      fill='#7B83EB'
      d='M58.559 28.298v22.096c0 4.099-1.355 8.076-3.87 11.325a18.8 18.8 0 0 1-10.016 6.646 18.83 18.83 0 0 1-12.013-.782 18.63 18.63 0 0 1-9.052-7.886 17.5 17.5 0 0 1-1.173-2.333 19 19 0 0 1-.769-2.332 18.7 18.7 0 0 1-.586-4.651V28.285c0-.459.083-.917.265-1.335s.433-.809.768-1.132a3.4 3.4 0 0 1 1.146-.755c.433-.176.88-.27 1.34-.27h30.453c.461 0 .922.094 1.342.27.433.175.81.431 1.145.755.321.323.587.714.768 1.132s.266.876.266 1.335z'
    />
    <path
      fill='currentColor'
      d='M36.697 15.504h-6.762a10.9 10.9 0 0 0 4.038 4.53 11.03 11.03 0 0 0 5.839 1.685v-3.1a3.07 3.07 0 0 0-.922-2.185 3.22 3.22 0 0 0-2.207-.917z'
      opacity={0.2}
    />
    <path
      fill='currentColor'
      d='M42.159 24.806v29.47c0 .701-.237 1.375-.684 1.928a3.08 3.08 0 0 1-1.747 1.079 2.3 2.3 0 0 1-.684.094h-16.61a19 19 0 0 1-.768-2.332 18.7 18.7 0 0 1-.586-4.651V28.297c0-.458.083-.916.265-1.334s.433-.81.768-1.133a3.4 3.4 0 0 1 1.146-.755 3.6 3.6 0 0 1 1.34-.27h17.574z'
      opacity={0.1}
    />
    <path
      fill='currentColor'
      d='M39.826 24.807v31.802c0 .23-.028.459-.098.674a3.1 3.1 0 0 1-1.076 1.74 3.05 3.05 0 0 1-1.941.674H23.62a17.5 17.5 0 0 1-1.173-2.333 19 19 0 0 1-.768-2.332 18.7 18.7 0 0 1-.587-4.651V28.285c0-.459.084-.917.266-1.335.181-.418.433-.809.768-1.132a3.4 3.4 0 0 1 1.145-.755c.434-.176.88-.27 1.342-.27H39.84z'
      opacity={0.2}
    />
    <path
      fill='currentColor'
      d='M39.826 24.806v27.151a3.07 3.07 0 0 1-.922 2.184 3.18 3.18 0 0 1-2.193.917H21.666a18.7 18.7 0 0 1-.586-4.651V28.311c0-.459.083-.917.265-1.335s.433-.809.768-1.132a3.4 3.4 0 0 1 1.146-.755 3.6 3.6 0 0 1 1.34-.27h15.227z'
      opacity={0.2}
    />
    <path
      fill='currentColor'
      d='M24.6 24.807c-.461 0-.922.094-1.341.269-.433.175-.81.431-1.146.755a3.7 3.7 0 0 0-.768 1.133 3.4 3.4 0 0 0-.265 1.334v22.096c0 1.564.195 3.128.586 4.651h12.698a3.1 3.1 0 0 0 2.193-.916c.587-.58.908-1.362.922-2.184V24.793H24.6z'
      opacity={0.2}
    />
    <path
      fill='#4B53BC'
      d='M3.115 15.504H34.35c.824 0 1.62.323 2.207.903s.908 1.375.908 2.198v31.02c0 .823-.335 1.618-.908 2.198a3.14 3.14 0 0 1-2.207.903H3.115c-.824 0-1.62-.323-2.207-.903A3.09 3.09 0 0 1 0 49.626V18.605c0-.823.335-1.618.908-2.198a3.14 3.14 0 0 1 2.207-.903'
    />
    <path
      fill='#fff'
      d='M28.064 27.071h-6.998V45.73H16.47V27.071H9.43v-4.584h18.648v4.584z'
    />
  </svg>
);
export default SvgIconMsTeams;
